module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "ch-title"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("List of Illustrations")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('p', {
    staticClass: "fnoindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/05_Fm02#fig1"
    }
  }, [_vm._v("The Crown of Victory")])]), _vm._v(" "), _c('p', {
    staticClass: "fnoindent1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#fig2"
    }
  }, [_vm._v("A Riverside Encampment")])]), _vm._v(" "), _c('p', {
    staticClass: "fnoindent1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter04#fig3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hadon Before Minruth")])]), _vm._v(" "), _c('p', {
    staticClass: "fnoindent1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter04#fig4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Leopards!")])]), _vm._v(" "), _c('p', {
    staticClass: "fnoindent1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter09#fig5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Klemquaba Contingent")])]), _vm._v(" "), _c('p', {
    staticClass: "fnoindent1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter10#fig6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kwasin Slays a Chief!")])]), _vm._v(" "), _c('p', {
    staticClass: "fnoindent1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter12#fig7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Meeting with Lalila")])]), _vm._v(" "), _c('p', {
    staticClass: "fnoindent1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter15#fig8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kwasin Exiled")])]), _vm._v(" "), _c('p', {
    staticClass: "fnoindent1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter17#fig9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Return of the Galley")])]), _vm._v(" "), _c('p', {
    staticClass: "fnoindent1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter20#fig10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In Awineth’s Cell")])]), _vm._v(" "), _c('p', {
    staticClass: "fnoindent1t"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Map#map1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Map 1—Ancient Africa")])]), _vm._v(" "), _c('p', {
    staticClass: "fnoindent1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Map#map2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Map 2—Kemu")])]), _vm._v(" "), _c('p', {
    staticClass: "fnoindent1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Map#map3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Map 3—Khokarsa")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1848a1aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_listofillustration.vue
// module id = 69
// module chunks = 0